import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MassImportComponent } from './mass-import/mass-import.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [MassImportComponent],
  imports: [
    CommonModule,
    FormsModule
    
  ],
  exports : [MassImportComponent]
})
export class MassModule { }
